import { white, blue600 } from 'material-ui/styles/colors';

const styles = {
    qrCodeIcon: {
        position: 'absolute',
        right: 92,
    },
    rightIcon: {
        position: 'absolute',
        right: 50,
    },
    rightVisibleIcon: {
        position: 'absolute',
        right: 10,
    },
    dropdown: {
        position: 'absolute',
        right: 50,
        height: 48,
        color: white,
        fontSize: 14,
        backgroundColor: blue600,
    },
    modal: {
        top: 0,
        padding: 0,
        width: '570px',
        height: '600px'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/openexplore/PointInfo/PointInfo.css.js